import React from 'react';

const As = () => {
    return (
        <div className="full-screen-image">
            <img className="responsive-image" src={`${process.env.PUBLIC_URL}/image/as/pc.png`} alt="Full Screen" />
            <style jsx>{`
                .full-screen-image {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .responsive-image {
                    width: 100%;
                }
                @media (max-width: 800px) {
                    .responsive-image {
                        content: url(${process.env.PUBLIC_URL}/image/as/mo.png);
                    }
                }
            `}</style>
        </div>
    );
};

export default As;